import { combineAllWatchers } from '@sonar-software/xuder';
import { combineReducers } from 'redux';
import { importsLatestCountsSlice } from './counts';
import { importsLatestGetSlice } from './get';
import { importsLatestSalesforceSlice } from './salesforce';

export const importsLatestReducers = combineReducers({
	counts: importsLatestCountsSlice.asyncReducers,
	get: importsLatestGetSlice.asyncReducers,
	salesforce: importsLatestSalesforceSlice.asyncReducers
});

export const importsLatestWatchers = combineAllWatchers([
	importsLatestCountsSlice.asyncWatchers,
	importsLatestGetSlice.asyncWatchers,
	importsLatestSalesforceSlice.asyncWatchers
]);
